
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import Message from '@/components/message.vue';
	import Dialog from '@/components/dialog.vue';
  import {
    memberLabelmemberLabelManager,
    memberLabelmemberLabelDelete,
    memberLabelmemberLabelSave
  } from "@/api/supplier"
  @Component({  
    name: '',
    components: {
      PageFooter,
			'slz-message': Message,
			'slz-dialog': Dialog,
    }
  })

  export default class ProductList extends Vue {
    private keywords = ''
    private tablelist:any = []
    private tableloading = false
		private pageNo = 1;
		private pageSize = 20;
		private total = 0;
    private sort:any = {
      prop:'',
      order:null
    }
    private rowmsg:any = {}
    private delShow = false
    private createShow = false
    private editShow = false

    private mounted () {
      this.gettablelist()
    }


    private async save(noTest:boolean){
      if(!noTest){
        if(!this.rowmsg.LabelName){
          this.$message.error('请输入标签')
          return
        }
        if(this.rowmsg.RelationCount>0){
          this.editShow = true
          this.createShow = false
          return
        }
      }
      try{  
        let res = await memberLabelmemberLabelSave(this.rowmsg)
        if(res.IsSuccess){
          this.$message.success('保存成功')
          this.gettablelist()
          this.createShow = false
        }
      }finally{
        //
      }
    }
    private toCreate(row){
      if(row.Id){
        this.rowmsg = JSON.parse(JSON.stringify(row))
      }else{
        this.rowmsg = {
          LabelName:'',
          Id:0
        }
      }
      this.createShow = true
    }
    private async confirmDel(){
      try{
        this.tableloading = true
        let res = await memberLabelmemberLabelDelete({
          Id:this.rowmsg.Id
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.gettablelist()
        }
      }finally{
        this.tableloading = false
      }
    }
    private toDel(row){
      this.rowmsg = row
      this.delShow = true
    }
    private sortChange({ column, prop, order }){
      this.sort = {
        prop:prop,
        order:order
      }
      this.gettablelist()
    }
    private toDetails(row){
      this.$router.push({
        path:'LabelManagementDetails',
        query:{
          LabelName:encodeURIComponent(row.LabelName),
          Id:row.Id,
          RelationCount:row.RelationCount,
        }
      })
    }
    private changePage(e){
      this.pageNo = e
      this.gettablelist()
    }
    private doSearch(){
      this.pageNo = 1
      this.gettablelist()
    }
    private clearSearch(){
      this.keywords = ''
      this.doSearch()
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let res = await memberLabelmemberLabelManager({
          Keywords:this.keywords,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize,
          OrderByType:this.sort.prop&&this.sort.order?1:0,
          IsAsc:this.sort.order==null?'':(this.sort.order=='ascending')
        })
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
  }
